import { render } from "./Transaction.vue?vue&type=template&id=21eae19e"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"

import "./Transaction.vue?vue&type=style&index=0&id=21eae19e&lang=css"

import exportComponent from "C:\\src\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__